import { render, staticRenderFns } from "./SalesForecastRecordList.vue?vue&type=template&id=6b7fc94e"
import script from "./SalesForecastRecordList.vue?vue&type=script&lang=js"
export * from "./SalesForecastRecordList.vue?vue&type=script&lang=js"
import style0 from "./SalesForecastRecordList.vue?vue&type=style&index=0&id=6b7fc94e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports